import React from 'react';
import '../CSS/TrainingExperience.css';

const TrainingExperience = () => {
    const trainings = [
        { training: "Leica Cyclone Register 360", year: "October 2021" },
        { training: "Leica RTC 360", year: "October 2021" },
        { training: "Leica Cyclone 3DR Fundamentals", year: "October 2021" },
        { training: "Buildsafe Retreat: Exponential Growth", year: "June 2021" },
        { training: "Autodesk Increase Design Efficiency Civil Infrastructure", year: "June 2021" },
        { training: "Technical Workflows On Concrete Bridge Design", year: "June 2021" },
        { training: "Project Management Course", year: "Feb 2020" },
        { training: "Autodesk Certified Instructor", year: "March 2021" },
        { training: "BIM Workshop Lagos", year: "July 2019" },
        { training: "BIM Workshop Ghana", year: "April 2019" },
        { training: "Structural Fabrication Strategy Autodesk", year: "September 2017" },
        { training: "Tecon Safety Course", year: "2015" },
        { training: "Helicopter Underwater Escape Technique ", year: "(HUET) 2015" },
        { training: "Basic Offshore Safety Induction Emergency training ", year: "(TBOSIET) 2015" },
    ];

    return (
        <div className='TrainingExperienceWrap'>
            <h1>TRAINING EXPERIENCES</h1>
            <div className='TrainingExperiences'>
            {trainings.map((item, index) => (
                <div className='TrainingExperience' key={index}>
                    <p>{item.training}</p>
                    <p>{item.year}</p>
                </div>
            ))}
        </div>
        </div>
    );
}

export default TrainingExperience;
